import { withTranslation, WithTranslation } from "react-i18next";
import { IVideosTabProps } from "../../../interfaces/props/ITabsProps";
import { IVideosTabState } from "../../../interfaces/states/ITabsState";
import * as pagerUtils from '../../../utils/pager.utils';
import { Component } from "react";
import React from "react";
import { PageSettingsModel } from "@syncfusion/ej2-grids";
import * as annexedCategoryUtils from '../../../utils/annexedCategory.utils';
import { IVideoAnnexed } from "../../../common/model/videoAnnexed.model";
import { annexesService } from "../../../services";
import './videosTab.scss';
import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Sort, Page, Resize } from "@syncfusion/ej2-react-grids";
import { Modal } from "react-bootstrap";
import ReactPlayer from "react-player";

type VideosTabPropsType = IVideosTabProps & WithTranslation;

class VideosTab extends Component<VideosTabPropsType, IVideosTabState> {

    private gridRef: GridComponent;
    public pageSettings: PageSettingsModel = {
        pageSize: pagerUtils.getMaxPageSize(),
        pageCount: pagerUtils.getPageCount(),
        pageSizes: pagerUtils.getPageSizes()
    };

    public constructor(props: VideosTabPropsType) {
        super(props);

        this.state = {
            showVideoModal: false,
            urlVideo: '',
            downloadButtonLoading: false
        }
    }

    public getDescriptionColumnTemplate(annex: IVideoAnnexed): JSX.Element {
        if (annex.thumbnailUrl) {
            return <img src={annex.thumbnailUrl} alt={annex.description} title={annex.description} className='thumbnail' onClick={() => this.onOpenVideoModal(annex)} />;
        }
        return <span className='e-link' onClick={() => this.onOpenVideoModal(annex)}>{annex.description}</span>
    }

    public async onOpenVideoModal(video: IVideoAnnexed): Promise<void> {
        const url = await annexesService.getVideoUrl(video.id);
        this.setState({ showVideoModal: true, urlVideo: url });
    }

    public getCategoryColumnTemplate(annex: IVideoAnnexed): JSX.Element {
        if (annex.annexedCategoryValue !== undefined && annex.annexedCategoryValue !== null) {
            return <span>{annexedCategoryUtils.getLocalizedText(this.props.i18n, annex.annexedCategoryValue)} </span>;
        }
        return <span />;
    }

    public getActionsColumnTemplate(annex: IVideoAnnexed, active: boolean): JSX.Element {
        const { i18n } = this.props;

        if (!annex.canBeDownloaded) {
            return null;
        }

        return (
            <div className='btn-group'>
                <button
                    type='button'
                    className='btn btn-sm btn-light'
                    title={i18n.t('reportDetail.actions.downloadVideo')}
                    onClick={() => this.onDownloadAnnexButtonClick(annex)}
                    disabled={active}
                >
                    {active
                        ? <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true' />
                        : <span className='icon icon-app-file-download' role='status' aria-hidden='true' />}
                </button>
            </div>
        )
    }

    public onDownloadAnnexButtonClick(annex: IVideoAnnexed) {
        if (this.state.downloadButtonLoading) {
            return;
        }
        this.setState({ downloadButtonLoading: true },
            () => {
                this.gridRef.refresh();
                annexesService.downloadFile(annex.id, annex.description, annex.annexedCategoryValue)
                    .finally(() => {
                        this.setState({ downloadButtonLoading: false });         
                        this.gridRef.refresh();               
                    })
            });
    }

    public render() {
        const { i18n, videos } = this.props;

        return (<div className='annexes-grid'>
                <GridComponent
                    dataSource={videos}
                    allowSorting={true}
                    allowPaging={true}
                    allowResizing={true}
                    pageSettings={this.pageSettings}
                    locale={i18n.language}
                    ref={(grid: GridComponent) => this.gridRef = grid}>
                    <ColumnsDirective>
                        <ColumnDirective
                            headerText={i18n.t('annex.visualization')}
                            field='description'
                            width='250'
                            template={(annex: IVideoAnnexed) => this.getDescriptionColumnTemplate(annex)}
                        />
                        <ColumnDirective
                            headerText={i18n.t('annex.annexedCategory')}
                            field='state'
                            width='75'
                            template={(annex: IVideoAnnexed) => this.getCategoryColumnTemplate(annex)}
                        />
                        <ColumnDirective
                            width='500'                            
                            template={(annex: IVideoAnnexed) => this.getActionsColumnTemplate(annex, this.state.downloadButtonLoading)} />
                    </ColumnsDirective>
                    <Inject services={[Sort, Page, Resize]} />
                </GridComponent>
                <Modal className='modal-apply' show={this.state.showVideoModal} onHide={() => this.handleClose()}>
                    <Modal.Header closeButton={true}>
                        <Modal.Title>{i18n.t('icons.testResultVideo')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ReactPlayer
                            url={this.state.urlVideo}
                            controls={true}
                            // Disable download button
                            config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                            // Disable right click
                            onContextMenu={(e: any) => e.preventDefault()}
                            playing={true}
                            className='aspect-ratio-16-9'
                        />
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    private handleClose(): void {
        this.setState({ showVideoModal: false, urlVideo: '' });
    }
}

export default withTranslation()(VideosTab);
